import { useEffect, useState } from 'react';
import { checkEliteEligibility, dismissEliteBanner } from '@/lib/api';

interface EliteStatus {
  showModal: boolean;
  dismiss: () => void;
}

export function useEliteStatus(playerId: string): EliteStatus {
  const whatsappUrl = import.meta.env.VITE_ELITE_WHATSAPP_URL;
  const [eligible, setEligible] = useState(false);

  useEffect(() => {
    if (!whatsappUrl) return;

    let cancelled = false;
    checkEliteEligibility(playerId).then((result) => {
      if (!cancelled) setEligible(result);
    });
    return () => {
      cancelled = true;
    };
  }, [playerId, whatsappUrl]);

  const dismiss = () => {
    setEligible(false);
    dismissEliteBanner(playerId);
  };

  return {
    showModal: eligible,
    dismiss,
  };
}
